import React from 'react';
import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';

import { token } from '@atlaskit/tokens';

import { borderRadius, gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { useQueryParamSync } from '../controllers/query-param-sync/index.tsx';
import Filters from './filters/index.tsx';
import Header from './header/index.tsx';
import { HistoricalCycleTime } from './historical-cycle-time/index.tsx';
import { IssueChart } from './issue-chart/index.tsx';
import { IssueTable } from './issue-table/index.tsx';
import { NoProvider } from './no-provider/index.tsx';
import PeriodFilter from './period-filter/index.tsx';

type CycleTimeBreakdownProps = {
	hasProviders: boolean;
};

const CycleTimeBreakdown = ({ hasProviders }: CycleTimeBreakdownProps) => {
	useQueryParamSync();

	return (
		<CycleTimeContainer>
			<Header />
			{hasProviders ? (
				<>
					<Filters />
					<ContentContainer>
						<HistoricalCycleTime />
						<PeriodContentContainer>
							<PeriodFilter />
							<IssueChart />
							<IssueTable />
						</PeriodContentContainer>
					</ContentContainer>
				</>
			) : (
				<ContentContainer>
					<NoProvider />
				</ContentContainer>
			)}
		</CycleTimeContainer>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const CycleTimeContainer = styled.div({
	padding: `0 ${token('space.400', '32px')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ContentContainer = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	borderRadius: `${gridSize * 2}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: token('elevation.surface.sunken', colors.N10A),
	padding: token('space.300', '24px'),
	marginTop: token('space.100', '8px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const PeriodContentContainer = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	borderRadius: `${borderRadius}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: token('elevation.surface', colors.N0),
	padding: token('space.200', '16px'),
	marginTop: token('space.100', '8px'),
	boxShadow: token(
		'elevation.shadow.raised',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		`0px 1px 1px ${colors.N50A},
${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ ''}
        0px 0px 1px ${colors.N60A}`,
	),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	minHeight: `${gridSize * 125}px`,
});

export default CycleTimeBreakdown;
